export default {
  getSmsBuyList: {
    method: 'get',
    url: 'sms/buy'
  },
  getSmsSendList: {
    method: 'get',
    url: 'sms/send'
  },
  getSmsRule: {
    method: 'get',
    url: 'sms/rule'
  },
  setSmsRule: {
    method: 'post',
    url: 'sms/rule'
  },
  getSmsConfig: {
    method: 'get',
    url: 'sms/server'
  },
  setSmsConfig: {
    method: 'post',
    url: 'sms/server'
  },
  getSmsTemplate: {
    method: 'get',
    url: 'sms/template'
  },
  addSmsTemplate: {
    method: 'post',
    url: 'sms/template'
  },
  reviseSmsTemplate: {
    method: 'put',
    url: 'sms/template'
  },
  deleteSmsTemplate: {
    method: 'delete',
    url: 'sms/template'
  },
  getProviderOption: {
    method: 'get',
    url: 'sms/provider'
  },
}
